<template>
  <v-container fluid class="pa-0 ma-0 primary fill-height">

    <v-layout wrap mt-4 pt-4>
      <v-flex mt-4 pt-4 xs12 lg8 offset-lg2 xl6 offset-xl3 px-3 text-center>
        <v-img :src="require('@/assets/img/logo_dark.png')" width="300" cover class="mx-auto"/>

        <template v-if="paymentReturn">
          <v-alert color="white" class="black--text mt-4" :value="true">
            <div class="headline font-weight-light">¡Gracias!</div>
            <p class="subheading">Te notificaremos cuando el pago haya sido procesado.</p>
          </v-alert>
        </template>

        <template v-else>
          <v-alert color="white" class="black--text mt-4" :value="true">
            <div class="headline font-weight-light">Has cancelado el pago <b>:(</b></div>
            <p class="subheading">No hay problema, puedes intentarlo en otro momento.</p>
          </v-alert>
        </template>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>

    export default{
        components:{},
        data(){
          return {}
        },
        mounted(){},
        computed:{
            paymentReturn(){
                var vm =  this
                const paymentResponse = vm.$route.query.paymentResponse
                return paymentResponse === 'return'
            },
        },
        methods:{},
    }
</script>

<style>
    .loading-container{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
</style>
